module.exports = __webpack_public_path__ + "img/gerente.741d3761.png";